import React from 'react';
import classes from './NavBar.module.scss';
import {useAppSelector} from "../../../shared/hooks/useAppSelector";
import TopBar from "../top-bar/TopBar";
import TabBar from "../tab-bar/TabBar";

const NavBar: React.FC = () => {
  const authenticated = useAppSelector(state => state.auth.authenticated);
  if (!authenticated) return null;

  return (
      <header className={classes.navigationContainer}>
        <TopBar/>
        <TabBar/>
      </header>
  );
};

export default NavBar;